// @generated by protobuf-ts 2.11.1 with parameter long_type_string,generate_dependencies,output_legacy_commonjs
// @generated from protobuf file "sennotech/base/examination/examination.proto" (package "base.examination", syntax proto3)
// tslint:disable
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { ExaminationService } from "./examination";
import type { ListExaminationReportHeadersResponse } from "./examination";
import type { ListExaminationReportHeadersRequest } from "./examination";
import type { ListExaminationReportsResponse } from "./examination";
import type { ListExaminationReportsRequest } from "./examination";
import type { CountExaminationReportByExamineesResponse } from "./examination";
import type { CountExaminationReportByExamineesRequest } from "./examination";
import type { CountExaminationReportByExaminersResponse } from "./examination";
import type { CountExaminationReportByExaminersRequest } from "./examination";
import type { ListExaminationReportByOrganizationIdAndTypeResponse } from "./examination";
import type { ListExaminationReportByOrganizationIdAndTypeRequest } from "./examination";
import type { BatchGetExaminationReportsByDetailIdResponse } from "./examination";
import type { BatchGetExaminationReportsByDetailIdRequest } from "./examination";
import type { GetExaminationReportByExamineeReportDetailIdResponse } from "./examination";
import type { GetExaminationReportByExamineeReportDetailIdRequest } from "./examination";
import type { UpdateExaminationReportByExamineeReportDetailIdResponse } from "./examination";
import type { UpdateExaminationReportByExamineeReportDetailIdRequest } from "./examination";
import type { GetExaminationReportPageByAccessTokenAndTypeResponse } from "./examination";
import type { GetExaminationReportPageByAccessTokenAndTypeRequest } from "./examination";
import type { GetExaminationReportPageByExamineeIdAndTypeResponse } from "./examination";
import type { GetExaminationReportPageByExamineeIdAndTypeRequest } from "./examination";
import type { GetExaminationReportPageByExamineeIdResponse } from "./examination";
import type { GetExaminationReportPageByExamineeIdRequest } from "./examination";
import type { GetExaminationReportPageByAccountIdAndTypeResponse } from "./examination";
import type { GetExaminationReportPageByAccountIdAndTypeRequest } from "./examination";
import type { GetExaminationReportPageByAccountIdResponse } from "./examination";
import type { GetExaminationReportPageByAccountIdRequest } from "./examination";
import type { GetExamineesExaminationReportListByReportTypeResponse } from "./examination";
import type { GetExamineesExaminationReportListByReportTypeRequest } from "./examination";
import type { DeleteExaminationReportByDetailIdResponse } from "./examination";
import type { DeleteExaminationReportByDetailIdRequest } from "./examination";
import type { DeleteAllExaminationReportRelationshipResponse } from "./examination";
import type { DeleteAllExaminationReportRelationshipRequest } from "./examination";
import type { DeleteExaminationReportRelationshipResponse } from "./examination";
import type { DeleteExaminationReportRelationshipRequest } from "./examination";
import type { ShareExaminationReportRequest } from "./examination";
import type { AddExaminationReportResponse } from "./examination";
import type { AddExaminationReportRequest } from "./examination";
import type { GetExaminationReportByIdResponse } from "./examination";
import type { GetExaminationReportByIdRequest } from "./examination";
import type { GetMyExaminationReportListResponse } from "./examination";
import type { GetMyExaminationReportListRequest } from "./examination";
import type { UpdateExaminationReportResponse } from "./examination";
import type { UpdateExaminationReportRequest } from "./examination";
import type { CreateExaminationReportResponse } from "./examination";
import type { CreateExaminationReportRequest } from "./examination";
import type { DeleteSymptomsRequest } from "./examination";
import type { ListSymptomsResponse } from "./examination";
import type { ListSymptomsRequest } from "./examination";
import type { PageListExamineeResponse } from "./examination";
import type { PageListExamineeRequest } from "./examination";
import type { CountExamineeByExaminersResponse } from "./examination";
import type { CountExamineeByExaminersRequest } from "./examination";
import type { ListExamineeResponse } from "./examination";
import type { ListExamineeRequest } from "./examination";
import type { ListExamineeListByExamineeAccountIdsResponse } from "./examination";
import type { ListExamineeListByExamineeAccountIdsRequest } from "./examination";
import type { GetExamineeListByIdsResponse } from "./examination";
import type { GetExamineeListByIdsRequest } from "./examination";
import type { UpdateExaminationRelationshipByIdResponse } from "./examination";
import type { UpdateExaminationRelationshipByIdRequest } from "./examination";
import type { ListExaminersResponse } from "./examination";
import type { ListExaminersRequest } from "./examination";
import type { GetExaminationRelationshipByAccessTokenResponse } from "./examination";
import type { GetExaminationRelationshipByAccessTokenRequest } from "./examination";
import type { GetMyAllExaminersResponse } from "./examination";
import type { GetMyAllExaminersRequest } from "./examination";
import type { GetExaminerByAccountIdResponse } from "./examination";
import type { GetExaminerByAccountIdRequest } from "./examination";
import type { CreateExaminerByAccountIdResponse } from "./examination";
import type { CreateExaminerByAccountIdRequest } from "./examination";
import type { CreateExaminerResponse } from "./examination";
import type { CreateExaminerRequest } from "./examination";
import type { GetExamineesExaminationReportListResponse } from "./examination";
import type { GetExamineesExaminationReportListRequest } from "./examination";
import type { GetExamineeListByExaminerAccountIdResponse } from "./examination";
import type { GetExamineeListByExaminerAccountIdRequest } from "./examination";
import type { GetMyExamineeResponse } from "./examination";
import type { GetMyExamineeRequest } from "./examination";
import type { GetExamineeByAccountIdResponse } from "./examination";
import type { GetExamineeByAccountIdRequest } from "./examination";
import type { GetExamineeByIdResponse } from "./examination";
import type { GetExamineeByIdRequest } from "./examination";
import type { UpdateExamineeResponse } from "./examination";
import type { UpdateExamineeRequest } from "./examination";
import type { SetExamineeAccountIdRequest } from "./examination";
import type { SetAccountIdForExamineeResponse } from "./examination";
import type { SetAccountIdForExamineeRequest } from "./examination";
import type { BatchDeleteExaminationRelationshipByExaminerAccountIdResponse } from "./examination";
import type { BatchDeleteExaminationRelationshipByExaminerAccountIdRequest } from "./examination";
import type { BatchDeleteExaminationRelationshipByOrganizationResponse } from "./examination";
import type { BatchDeleteExaminationRelationshipByOrganizationRequest } from "./examination";
import type { DeleteExaminationRelationshipByAccountIdResponse } from "./examination";
import type { DeleteExaminationRelationshipByAccountIdRequest } from "./examination";
import type { DeleteExaminationRelationshipResponse } from "./examination";
import type { DeleteExaminationRelationshipRequest } from "./examination";
import type { ShareExamineeResponse } from "./examination";
import type { ShareExamineeRequest } from "./examination";
import type { AddExamineeToExaminationRelationshipResponse } from "./examination";
import type { AddExamineeToExaminationRelationshipRequest } from "./examination";
import type { GetExamineeListByOrganizationIdResponse } from "./examination";
import type { GetExamineeListByOrganizationIdRequest } from "./examination";
import type { GetMyExamineeListResponse } from "./examination";
import type { GetMyExamineeListRequest } from "./examination";
import type { DecodeExamineeIdCodeResponse } from "./examination";
import type { DecodeExamineeIdCodeRequest } from "./examination";
import type { GetExamineeIdEncryptAlphabetResponse } from "./examination";
import type { ExportExamineesListResponse } from "./examination";
import type { ExportExamineesListRequest } from "./examination";
import type { UnbindExamineeFromExaminerRequest } from "./examination";
import type { BindExamineeToExaminerRequest } from "./examination";
import type { GetBatchCreateExamineesExcelTemplateResponse } from "./examination";
import type { Empty } from "../../google/protobuf/empty";
import type { BatchCreateExamineesWithExcelResponse } from "./examination";
import type { BatchCreateExamineesWithExcelRequest } from "./examination";
import type { GetPresignedPutObjectUrlResponse } from "./examination";
import type { GetPresignedPutObjectUrlRequest } from "./examination";
import type { BatchCreateExamineesResponse } from "./examination";
import type { BatchCreateExamineesRequest } from "./examination";
import type { CreateExamineeResponse } from "./examination";
import type { CreateExamineeRequest } from "./examination";
import type { AddExamineeMyselfResponse } from "./examination";
import type { AddExamineeMyselfRequest } from "./examination";
import type { AddExamineeResponse } from "./examination";
import type { AddExamineeRequest } from "./examination";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { AddExamineeByAccountIdResponse } from "./examination";
import type { AddExamineeByAccountIdRequest } from "./examination";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * 检测模块
 *
 * @generated from protobuf service base.examination.ExaminationService
 */
export interface IExaminationServiceClient {
    /**
     * region 检测人检测对象
     * 添加检测对象通过AccountId
     *
     * @generated from protobuf rpc: AddExamineeByAccountId
     */
    addExamineeByAccountId(input: AddExamineeByAccountIdRequest, options?: RpcOptions): UnaryCall<AddExamineeByAccountIdRequest, AddExamineeByAccountIdResponse>;
    /**
     * 添加检测对象
     *
     * @generated from protobuf rpc: AddExaminee
     */
    addExaminee(input: AddExamineeRequest, options?: RpcOptions): UnaryCall<AddExamineeRequest, AddExamineeResponse>;
    /**
     * 添加自己为检测对象
     *
     * @generated from protobuf rpc: AddExamineeMyself
     */
    addExamineeMyself(input: AddExamineeMyselfRequest, options?: RpcOptions): UnaryCall<AddExamineeMyselfRequest, AddExamineeMyselfResponse>;
    /**
     * @generated from protobuf rpc: CreateExaminee
     */
    createExaminee(input: CreateExamineeRequest, options?: RpcOptions): UnaryCall<CreateExamineeRequest, CreateExamineeResponse>;
    /**
     * @generated from protobuf rpc: BatchCreateExaminees
     */
    batchCreateExaminees(input: BatchCreateExamineesRequest, options?: RpcOptions): UnaryCall<BatchCreateExamineesRequest, BatchCreateExamineesResponse>;
    /**
     * @generated from protobuf rpc: GetPresignedPutObjectUrl
     */
    getPresignedPutObjectUrl(input: GetPresignedPutObjectUrlRequest, options?: RpcOptions): UnaryCall<GetPresignedPutObjectUrlRequest, GetPresignedPutObjectUrlResponse>;
    /**
     * @generated from protobuf rpc: BatchCreateExamineesWithExcel
     */
    batchCreateExamineesWithExcel(input: BatchCreateExamineesWithExcelRequest, options?: RpcOptions): UnaryCall<BatchCreateExamineesWithExcelRequest, BatchCreateExamineesWithExcelResponse>;
    /**
     * @generated from protobuf rpc: GetBatchCreateExamineesExcelTemplate
     */
    getBatchCreateExamineesExcelTemplate(input: Empty, options?: RpcOptions): UnaryCall<Empty, GetBatchCreateExamineesExcelTemplateResponse>;
    /**
     * @generated from protobuf rpc: BindExamineeToExaminer
     */
    bindExamineeToExaminer(input: BindExamineeToExaminerRequest, options?: RpcOptions): UnaryCall<BindExamineeToExaminerRequest, Empty>;
    /**
     * @generated from protobuf rpc: UnbindExamineeFromExaminer
     */
    unbindExamineeFromExaminer(input: UnbindExamineeFromExaminerRequest, options?: RpcOptions): UnaryCall<UnbindExamineeFromExaminerRequest, Empty>;
    /**
     * @generated from protobuf rpc: ExportExamineesList
     */
    exportExamineesList(input: ExportExamineesListRequest, options?: RpcOptions): UnaryCall<ExportExamineesListRequest, ExportExamineesListResponse>;
    /**
     * @generated from protobuf rpc: GetExamineeIdEncryptAlphabet
     */
    getExamineeIdEncryptAlphabet(input: Empty, options?: RpcOptions): UnaryCall<Empty, GetExamineeIdEncryptAlphabetResponse>;
    /**
     * @generated from protobuf rpc: DecodeExamineeIdCode
     */
    decodeExamineeIdCode(input: DecodeExamineeIdCodeRequest, options?: RpcOptions): UnaryCall<DecodeExamineeIdCodeRequest, DecodeExamineeIdCodeResponse>;
    /**
     * 获取我的检测对象列表
     *
     * @generated from protobuf rpc: GetMyExamineeList
     */
    getMyExamineeList(input: GetMyExamineeListRequest, options?: RpcOptions): UnaryCall<GetMyExamineeListRequest, GetMyExamineeListResponse>;
    /**
     * 按组织获取检测对象列表
     *
     * @generated from protobuf rpc: GetExamineeListByOrganizationId
     */
    getExamineeListByOrganizationId(input: GetExamineeListByOrganizationIdRequest, options?: RpcOptions): UnaryCall<GetExamineeListByOrganizationIdRequest, GetExamineeListByOrganizationIdResponse>;
    /**
     * 将检测对象加入好友列表
     *
     * @generated from protobuf rpc: AddExamineeToExaminationRelationship
     */
    addExamineeToExaminationRelationship(input: AddExamineeToExaminationRelationshipRequest, options?: RpcOptions): UnaryCall<AddExamineeToExaminationRelationshipRequest, AddExamineeToExaminationRelationshipResponse>;
    /**
     * 分享检测人
     *
     * @generated from protobuf rpc: ShareExamineeByAccessToken
     */
    shareExamineeByAccessToken(input: ShareExamineeRequest, options?: RpcOptions): UnaryCall<ShareExamineeRequest, ShareExamineeResponse>;
    /**
     * 删除检测对象(删除的只是目前账号与该检测对象的关系)
     *
     * @generated from protobuf rpc: DeleteExaminationRelationship
     */
    deleteExaminationRelationship(input: DeleteExaminationRelationshipRequest, options?: RpcOptions): UnaryCall<DeleteExaminationRelationshipRequest, DeleteExaminationRelationshipResponse>;
    /**
     * 删除检测对象(删除的只是目前账号与该检测对象的关系)
     *
     * @generated from protobuf rpc: DeleteExaminationRelationshipByAccountId
     */
    deleteExaminationRelationshipByAccountId(input: DeleteExaminationRelationshipByAccountIdRequest, options?: RpcOptions): UnaryCall<DeleteExaminationRelationshipByAccountIdRequest, DeleteExaminationRelationshipByAccountIdResponse>;
    /**
     * 按组织批量删除检测关系（检测人和被检测人的关系）
     *
     * @generated from protobuf rpc: BatchDeleteExaminationRelationshipByOrganization
     */
    batchDeleteExaminationRelationshipByOrganization(input: BatchDeleteExaminationRelationshipByOrganizationRequest, options?: RpcOptions): UnaryCall<BatchDeleteExaminationRelationshipByOrganizationRequest, BatchDeleteExaminationRelationshipByOrganizationResponse>;
    /**
     * 按检测人批量删除检测关系
     *
     * @generated from protobuf rpc: BatchDeleteExaminationRelationshipByExaminerAccountId
     */
    batchDeleteExaminationRelationshipByExaminerAccountId(input: BatchDeleteExaminationRelationshipByExaminerAccountIdRequest, options?: RpcOptions): UnaryCall<BatchDeleteExaminationRelationshipByExaminerAccountIdRequest, BatchDeleteExaminationRelationshipByExaminerAccountIdResponse>;
    /**
     * 绑定accountId
     *
     * @generated from protobuf rpc: SetAccountIdForExaminee
     */
    setAccountIdForExaminee(input: SetAccountIdForExamineeRequest, options?: RpcOptions): UnaryCall<SetAccountIdForExamineeRequest, SetAccountIdForExamineeResponse>;
    /**
     * @generated from protobuf rpc: SetExamineeAccountId
     */
    setExamineeAccountId(input: SetExamineeAccountIdRequest, options?: RpcOptions): UnaryCall<SetExamineeAccountIdRequest, Empty>;
    /**
     * 修改检测对象信息
     *
     * @generated from protobuf rpc: UpdateExaminee
     */
    updateExaminee(input: UpdateExamineeRequest, options?: RpcOptions): UnaryCall<UpdateExamineeRequest, UpdateExamineeResponse>;
    /**
     * 获取检测对象通过检测对象id
     *
     * @generated from protobuf rpc: GetExamineeById
     */
    getExamineeById(input: GetExamineeByIdRequest, options?: RpcOptions): UnaryCall<GetExamineeByIdRequest, GetExamineeByIdResponse>;
    /**
     * 通过examinee自己的account_id获取检测对象信息，参见：CreateExaminee
     *
     * @generated from protobuf rpc: GetExamineeByAccountId
     */
    getExamineeByAccountId(input: GetExamineeByAccountIdRequest, options?: RpcOptions): UnaryCall<GetExamineeByAccountIdRequest, GetExamineeByAccountIdResponse>;
    /**
     * @generated from protobuf rpc: GetMyExaminee
     */
    getMyExaminee(input: GetMyExamineeRequest, options?: RpcOptions): UnaryCall<GetMyExamineeRequest, GetMyExamineeResponse>;
    /**
     * 根据accountId查找检测对象列表
     *
     * @generated from protobuf rpc: GetExamineeListByExaminerAccountId
     */
    getExamineeListByExaminerAccountId(input: GetExamineeListByExaminerAccountIdRequest, options?: RpcOptions): UnaryCall<GetExamineeListByExaminerAccountIdRequest, GetExamineeListByExaminerAccountIdResponse>;
    /**
     * 获取检验人报告列表
     *
     * @generated from protobuf rpc: GetExamineesExaminationReportList
     */
    getExamineesExaminationReportList(input: GetExamineesExaminationReportListRequest, options?: RpcOptions): UnaryCall<GetExamineesExaminationReportListRequest, GetExamineesExaminationReportListResponse>;
    /**
     * 添加查验人
     *
     * @generated from protobuf rpc: CreateExaminer
     */
    createExaminer(input: CreateExaminerRequest, options?: RpcOptions): UnaryCall<CreateExaminerRequest, CreateExaminerResponse>;
    /**
     * 添加查验人
     *
     * @generated from protobuf rpc: CreateExaminerByAccountId
     */
    createExaminerByAccountId(input: CreateExaminerByAccountIdRequest, options?: RpcOptions): UnaryCall<CreateExaminerByAccountIdRequest, CreateExaminerByAccountIdResponse>;
    /**
     * 根据检测人ID获取检测人信息
     *
     * @generated from protobuf rpc: GetExaminerByAccountId
     */
    getExaminerByAccountId(input: GetExaminerByAccountIdRequest, options?: RpcOptions): UnaryCall<GetExaminerByAccountIdRequest, GetExaminerByAccountIdResponse>;
    /**
     * 获取查验人列表
     *
     * @generated from protobuf rpc: GetMyAllExaminers
     */
    getMyAllExaminers(input: GetMyAllExaminersRequest, options?: RpcOptions): UnaryCall<GetMyAllExaminersRequest, GetMyAllExaminersResponse>;
    /**
     * 查看我的检测人关系（还有能否操作）
     *
     * @generated from protobuf rpc: GetExaminationRelationshipByAccessToken
     */
    getExaminationRelationshipByAccessToken(input: GetExaminationRelationshipByAccessTokenRequest, options?: RpcOptions): UnaryCall<GetExaminationRelationshipByAccessTokenRequest, GetExaminationRelationshipByAccessTokenResponse>;
    /**
     * @generated from protobuf rpc: ListExaminers
     */
    listExaminers(input: ListExaminersRequest, options?: RpcOptions): UnaryCall<ListExaminersRequest, ListExaminersResponse>;
    /**
     * 修改被检测人关系
     *
     * @generated from protobuf rpc: UpdateExaminationRelationshipById
     */
    updateExaminationRelationshipById(input: UpdateExaminationRelationshipByIdRequest, options?: RpcOptions): UnaryCall<UpdateExaminationRelationshipByIdRequest, UpdateExaminationRelationshipByIdResponse>;
    /**
     * 获取被检测人列表通过被检测人id
     *
     * @generated from protobuf rpc: GetExamineeListByIds
     */
    getExamineeListByIds(input: GetExamineeListByIdsRequest, options?: RpcOptions): UnaryCall<GetExamineeListByIdsRequest, GetExamineeListByIdsResponse>;
    /**
     * 根据examineeAccountId和client获取Examinee列表信息
     *
     * @generated from protobuf rpc: ListExamineeListByExamineeAccountIds
     */
    listExamineeListByExamineeAccountIds(input: ListExamineeListByExamineeAccountIdsRequest, options?: RpcOptions): UnaryCall<ListExamineeListByExamineeAccountIdsRequest, ListExamineeListByExamineeAccountIdsResponse>;
    /**
     * 根据被检测人名字查看被检测者信息列表
     *
     * @generated from protobuf rpc: ListExaminee
     */
    listExaminee(input: ListExamineeRequest, options?: RpcOptions): UnaryCall<ListExamineeRequest, ListExamineeResponse>;
    /**
     * @generated from protobuf rpc: CountExamineeByExaminers
     */
    countExamineeByExaminers(input: CountExamineeByExaminersRequest, options?: RpcOptions): UnaryCall<CountExamineeByExaminersRequest, CountExamineeByExaminersResponse>;
    /**
     * 分页查看检测对象列表，根据accountId
     *
     * @generated from protobuf rpc: PageListExaminee
     */
    pageListExaminee(input: PageListExamineeRequest, options?: RpcOptions): UnaryCall<PageListExamineeRequest, PageListExamineeResponse>;
    /**
     * 获取症状标签列表
     *
     * @generated from protobuf rpc: ListSymptoms
     */
    listSymptoms(input: ListSymptomsRequest, options?: RpcOptions): UnaryCall<ListSymptomsRequest, ListSymptomsResponse>;
    /**
     * 获取症状标签列表
     *
     * @generated from protobuf rpc: DeleteSymptoms
     */
    deleteSymptoms(input: DeleteSymptomsRequest, options?: RpcOptions): UnaryCall<DeleteSymptomsRequest, Empty>;
    /**
     * region 检测报告
     * 增加一份报告
     *
     * @generated from protobuf rpc: CreateExaminationReport
     */
    createExaminationReport(input: CreateExaminationReportRequest, options?: RpcOptions): UnaryCall<CreateExaminationReportRequest, CreateExaminationReportResponse>;
    /**
     * 修改报告
     *
     * @generated from protobuf rpc: UpdateExaminationReport
     */
    updateExaminationReport(input: UpdateExaminationReportRequest, options?: RpcOptions): UnaryCall<UpdateExaminationReportRequest, UpdateExaminationReportResponse>;
    /**
     * 获取我的报告列表
     *
     * @generated from protobuf rpc: GetMyExaminationReportList
     */
    getMyExaminationReportList(input: GetMyExaminationReportListRequest, options?: RpcOptions): UnaryCall<GetMyExaminationReportListRequest, GetMyExaminationReportListResponse>;
    /**
     * 查询一份检测报告记录详情
     *
     * @generated from protobuf rpc: GetExaminationReportById
     */
    getExaminationReportById(input: GetExaminationReportByIdRequest, options?: RpcOptions): UnaryCall<GetExaminationReportByIdRequest, GetExaminationReportByIdResponse>;
    /**
     * 分享一份报告
     *
     * @generated from protobuf rpc: AddExaminationReport
     */
    addExaminationReport(input: AddExaminationReportRequest, options?: RpcOptions): UnaryCall<AddExaminationReportRequest, AddExaminationReportResponse>;
    /**
     * @generated from protobuf rpc: ShareExaminationReport
     */
    shareExaminationReport(input: ShareExaminationReportRequest, options?: RpcOptions): UnaryCall<ShareExaminationReportRequest, Empty>;
    /**
     * 删除我的一份检测报告记录
     *
     * @generated from protobuf rpc: DeleteExaminationReportRelationship
     */
    deleteExaminationReportRelationship(input: DeleteExaminationReportRelationshipRequest, options?: RpcOptions): UnaryCall<DeleteExaminationReportRelationshipRequest, DeleteExaminationReportRelationshipResponse>;
    /**
     * 删除我作为检测对象下所有的检测报告记录（既删除包括我分享出去或别人为我检测的报告记录）
     *
     * @generated from protobuf rpc: DeleteAllExaminationReportRelationship
     */
    deleteAllExaminationReportRelationship(input: DeleteAllExaminationReportRelationshipRequest, options?: RpcOptions): UnaryCall<DeleteAllExaminationReportRelationshipRequest, DeleteAllExaminationReportRelationshipResponse>;
    /**
     * @generated from protobuf rpc: DeleteExaminationReportByDetailId
     */
    deleteExaminationReportByDetailId(input: DeleteExaminationReportByDetailIdRequest, options?: RpcOptions): UnaryCall<DeleteExaminationReportByDetailIdRequest, DeleteExaminationReportByDetailIdResponse>;
    /**
     * 获取检验人报告列表（根据examineeId和检测类型获取检测者某一类型的报告列表）
     *
     * @generated from protobuf rpc: GetExamineesExaminationReportListByReportType
     */
    getExamineesExaminationReportListByReportType(input: GetExamineesExaminationReportListByReportTypeRequest, options?: RpcOptions): UnaryCall<GetExamineesExaminationReportListByReportTypeRequest, GetExamineesExaminationReportListByReportTypeResponse>;
    /**
     * 获取报告列表
     *
     * @generated from protobuf rpc: GetExaminationReportPageByAccountId
     */
    getExaminationReportPageByAccountId(input: GetExaminationReportPageByAccountIdRequest, options?: RpcOptions): UnaryCall<GetExaminationReportPageByAccountIdRequest, GetExaminationReportPageByAccountIdResponse>;
    /**
     * 获取报告列表
     *
     * @generated from protobuf rpc: GetExaminationReportPageByAccountIdAndType
     */
    getExaminationReportPageByAccountIdAndType(input: GetExaminationReportPageByAccountIdAndTypeRequest, options?: RpcOptions): UnaryCall<GetExaminationReportPageByAccountIdAndTypeRequest, GetExaminationReportPageByAccountIdAndTypeResponse>;
    /**
     * 获取报告列表
     *
     * @generated from protobuf rpc: GetExaminationReportPageByExamineeId
     */
    getExaminationReportPageByExamineeId(input: GetExaminationReportPageByExamineeIdRequest, options?: RpcOptions): UnaryCall<GetExaminationReportPageByExamineeIdRequest, GetExaminationReportPageByExamineeIdResponse>;
    /**
     * 获取报告列表
     *
     * @generated from protobuf rpc: GetExaminationReportPageByExamineeIdAndType
     */
    getExaminationReportPageByExamineeIdAndType(input: GetExaminationReportPageByExamineeIdAndTypeRequest, options?: RpcOptions): UnaryCall<GetExaminationReportPageByExamineeIdAndTypeRequest, GetExaminationReportPageByExamineeIdAndTypeResponse>;
    /**
     * 根据accessToken获取报告列表
     *
     * @generated from protobuf rpc: GetExaminationReportPageByAccessTokenAndType
     */
    getExaminationReportPageByAccessTokenAndType(input: GetExaminationReportPageByAccessTokenAndTypeRequest, options?: RpcOptions): UnaryCall<GetExaminationReportPageByAccessTokenAndTypeRequest, GetExaminationReportPageByAccessTokenAndTypeResponse>;
    /**
     * 修改报告
     *
     * @generated from protobuf rpc: UpdateExaminationReportByExamineeReportDetailId
     */
    updateExaminationReportByExamineeReportDetailId(input: UpdateExaminationReportByExamineeReportDetailIdRequest, options?: RpcOptions): UnaryCall<UpdateExaminationReportByExamineeReportDetailIdRequest, UpdateExaminationReportByExamineeReportDetailIdResponse>;
    /**
     * 查询一份检测报告记录详情
     *
     * @generated from protobuf rpc: GetExaminationReportByExamineeReportDetailId
     */
    getExaminationReportByExamineeReportDetailId(input: GetExaminationReportByExamineeReportDetailIdRequest, options?: RpcOptions): UnaryCall<GetExaminationReportByExamineeReportDetailIdRequest, GetExaminationReportByExamineeReportDetailIdResponse>;
    /**
     * @generated from protobuf rpc: BatchGetExaminationReportsByDetailId
     */
    batchGetExaminationReportsByDetailId(input: BatchGetExaminationReportsByDetailIdRequest, options?: RpcOptions): UnaryCall<BatchGetExaminationReportsByDetailIdRequest, BatchGetExaminationReportsByDetailIdResponse>;
    /**
     * 根据组织ID和检测类型获取检测列表
     *
     * @generated from protobuf rpc: ListExaminationReportByOrganizationIdAndType
     */
    listExaminationReportByOrganizationIdAndType(input: ListExaminationReportByOrganizationIdAndTypeRequest, options?: RpcOptions): UnaryCall<ListExaminationReportByOrganizationIdAndTypeRequest, ListExaminationReportByOrganizationIdAndTypeResponse>;
    /**
     * @generated from protobuf rpc: CountExaminationReportByExaminers
     */
    countExaminationReportByExaminers(input: CountExaminationReportByExaminersRequest, options?: RpcOptions): UnaryCall<CountExaminationReportByExaminersRequest, CountExaminationReportByExaminersResponse>;
    /**
     * @generated from protobuf rpc: CountExaminationReportByExaminees
     */
    countExaminationReportByExaminees(input: CountExaminationReportByExamineesRequest, options?: RpcOptions): UnaryCall<CountExaminationReportByExamineesRequest, CountExaminationReportByExamineesResponse>;
    /**
     * @generated from protobuf rpc: ListExaminationReports
     */
    listExaminationReports(input: ListExaminationReportsRequest, options?: RpcOptions): UnaryCall<ListExaminationReportsRequest, ListExaminationReportsResponse>;
    /**
     * @generated from protobuf rpc: ListExaminationReportHeaders
     */
    listExaminationReportHeaders(input: ListExaminationReportHeadersRequest, options?: RpcOptions): UnaryCall<ListExaminationReportHeadersRequest, ListExaminationReportHeadersResponse>;
}
/**
 * 检测模块
 *
 * @generated from protobuf service base.examination.ExaminationService
 */
export class ExaminationServiceClient implements IExaminationServiceClient, ServiceInfo {
    typeName = ExaminationService.typeName;
    methods = ExaminationService.methods;
    options = ExaminationService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * region 检测人检测对象
     * 添加检测对象通过AccountId
     *
     * @generated from protobuf rpc: AddExamineeByAccountId
     */
    addExamineeByAccountId(input: AddExamineeByAccountIdRequest, options?: RpcOptions): UnaryCall<AddExamineeByAccountIdRequest, AddExamineeByAccountIdResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<AddExamineeByAccountIdRequest, AddExamineeByAccountIdResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * 添加检测对象
     *
     * @generated from protobuf rpc: AddExaminee
     */
    addExaminee(input: AddExamineeRequest, options?: RpcOptions): UnaryCall<AddExamineeRequest, AddExamineeResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<AddExamineeRequest, AddExamineeResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * 添加自己为检测对象
     *
     * @generated from protobuf rpc: AddExamineeMyself
     */
    addExamineeMyself(input: AddExamineeMyselfRequest, options?: RpcOptions): UnaryCall<AddExamineeMyselfRequest, AddExamineeMyselfResponse> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<AddExamineeMyselfRequest, AddExamineeMyselfResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CreateExaminee
     */
    createExaminee(input: CreateExamineeRequest, options?: RpcOptions): UnaryCall<CreateExamineeRequest, CreateExamineeResponse> {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept<CreateExamineeRequest, CreateExamineeResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: BatchCreateExaminees
     */
    batchCreateExaminees(input: BatchCreateExamineesRequest, options?: RpcOptions): UnaryCall<BatchCreateExamineesRequest, BatchCreateExamineesResponse> {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return stackIntercept<BatchCreateExamineesRequest, BatchCreateExamineesResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetPresignedPutObjectUrl
     */
    getPresignedPutObjectUrl(input: GetPresignedPutObjectUrlRequest, options?: RpcOptions): UnaryCall<GetPresignedPutObjectUrlRequest, GetPresignedPutObjectUrlResponse> {
        const method = this.methods[5], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetPresignedPutObjectUrlRequest, GetPresignedPutObjectUrlResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: BatchCreateExamineesWithExcel
     */
    batchCreateExamineesWithExcel(input: BatchCreateExamineesWithExcelRequest, options?: RpcOptions): UnaryCall<BatchCreateExamineesWithExcelRequest, BatchCreateExamineesWithExcelResponse> {
        const method = this.methods[6], opt = this._transport.mergeOptions(options);
        return stackIntercept<BatchCreateExamineesWithExcelRequest, BatchCreateExamineesWithExcelResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetBatchCreateExamineesExcelTemplate
     */
    getBatchCreateExamineesExcelTemplate(input: Empty, options?: RpcOptions): UnaryCall<Empty, GetBatchCreateExamineesExcelTemplateResponse> {
        const method = this.methods[7], opt = this._transport.mergeOptions(options);
        return stackIntercept<Empty, GetBatchCreateExamineesExcelTemplateResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: BindExamineeToExaminer
     */
    bindExamineeToExaminer(input: BindExamineeToExaminerRequest, options?: RpcOptions): UnaryCall<BindExamineeToExaminerRequest, Empty> {
        const method = this.methods[8], opt = this._transport.mergeOptions(options);
        return stackIntercept<BindExamineeToExaminerRequest, Empty>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UnbindExamineeFromExaminer
     */
    unbindExamineeFromExaminer(input: UnbindExamineeFromExaminerRequest, options?: RpcOptions): UnaryCall<UnbindExamineeFromExaminerRequest, Empty> {
        const method = this.methods[9], opt = this._transport.mergeOptions(options);
        return stackIntercept<UnbindExamineeFromExaminerRequest, Empty>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ExportExamineesList
     */
    exportExamineesList(input: ExportExamineesListRequest, options?: RpcOptions): UnaryCall<ExportExamineesListRequest, ExportExamineesListResponse> {
        const method = this.methods[10], opt = this._transport.mergeOptions(options);
        return stackIntercept<ExportExamineesListRequest, ExportExamineesListResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetExamineeIdEncryptAlphabet
     */
    getExamineeIdEncryptAlphabet(input: Empty, options?: RpcOptions): UnaryCall<Empty, GetExamineeIdEncryptAlphabetResponse> {
        const method = this.methods[11], opt = this._transport.mergeOptions(options);
        return stackIntercept<Empty, GetExamineeIdEncryptAlphabetResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: DecodeExamineeIdCode
     */
    decodeExamineeIdCode(input: DecodeExamineeIdCodeRequest, options?: RpcOptions): UnaryCall<DecodeExamineeIdCodeRequest, DecodeExamineeIdCodeResponse> {
        const method = this.methods[12], opt = this._transport.mergeOptions(options);
        return stackIntercept<DecodeExamineeIdCodeRequest, DecodeExamineeIdCodeResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * 获取我的检测对象列表
     *
     * @generated from protobuf rpc: GetMyExamineeList
     */
    getMyExamineeList(input: GetMyExamineeListRequest, options?: RpcOptions): UnaryCall<GetMyExamineeListRequest, GetMyExamineeListResponse> {
        const method = this.methods[13], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetMyExamineeListRequest, GetMyExamineeListResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * 按组织获取检测对象列表
     *
     * @generated from protobuf rpc: GetExamineeListByOrganizationId
     */
    getExamineeListByOrganizationId(input: GetExamineeListByOrganizationIdRequest, options?: RpcOptions): UnaryCall<GetExamineeListByOrganizationIdRequest, GetExamineeListByOrganizationIdResponse> {
        const method = this.methods[14], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetExamineeListByOrganizationIdRequest, GetExamineeListByOrganizationIdResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * 将检测对象加入好友列表
     *
     * @generated from protobuf rpc: AddExamineeToExaminationRelationship
     */
    addExamineeToExaminationRelationship(input: AddExamineeToExaminationRelationshipRequest, options?: RpcOptions): UnaryCall<AddExamineeToExaminationRelationshipRequest, AddExamineeToExaminationRelationshipResponse> {
        const method = this.methods[15], opt = this._transport.mergeOptions(options);
        return stackIntercept<AddExamineeToExaminationRelationshipRequest, AddExamineeToExaminationRelationshipResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * 分享检测人
     *
     * @generated from protobuf rpc: ShareExamineeByAccessToken
     */
    shareExamineeByAccessToken(input: ShareExamineeRequest, options?: RpcOptions): UnaryCall<ShareExamineeRequest, ShareExamineeResponse> {
        const method = this.methods[16], opt = this._transport.mergeOptions(options);
        return stackIntercept<ShareExamineeRequest, ShareExamineeResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * 删除检测对象(删除的只是目前账号与该检测对象的关系)
     *
     * @generated from protobuf rpc: DeleteExaminationRelationship
     */
    deleteExaminationRelationship(input: DeleteExaminationRelationshipRequest, options?: RpcOptions): UnaryCall<DeleteExaminationRelationshipRequest, DeleteExaminationRelationshipResponse> {
        const method = this.methods[17], opt = this._transport.mergeOptions(options);
        return stackIntercept<DeleteExaminationRelationshipRequest, DeleteExaminationRelationshipResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * 删除检测对象(删除的只是目前账号与该检测对象的关系)
     *
     * @generated from protobuf rpc: DeleteExaminationRelationshipByAccountId
     */
    deleteExaminationRelationshipByAccountId(input: DeleteExaminationRelationshipByAccountIdRequest, options?: RpcOptions): UnaryCall<DeleteExaminationRelationshipByAccountIdRequest, DeleteExaminationRelationshipByAccountIdResponse> {
        const method = this.methods[18], opt = this._transport.mergeOptions(options);
        return stackIntercept<DeleteExaminationRelationshipByAccountIdRequest, DeleteExaminationRelationshipByAccountIdResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * 按组织批量删除检测关系（检测人和被检测人的关系）
     *
     * @generated from protobuf rpc: BatchDeleteExaminationRelationshipByOrganization
     */
    batchDeleteExaminationRelationshipByOrganization(input: BatchDeleteExaminationRelationshipByOrganizationRequest, options?: RpcOptions): UnaryCall<BatchDeleteExaminationRelationshipByOrganizationRequest, BatchDeleteExaminationRelationshipByOrganizationResponse> {
        const method = this.methods[19], opt = this._transport.mergeOptions(options);
        return stackIntercept<BatchDeleteExaminationRelationshipByOrganizationRequest, BatchDeleteExaminationRelationshipByOrganizationResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * 按检测人批量删除检测关系
     *
     * @generated from protobuf rpc: BatchDeleteExaminationRelationshipByExaminerAccountId
     */
    batchDeleteExaminationRelationshipByExaminerAccountId(input: BatchDeleteExaminationRelationshipByExaminerAccountIdRequest, options?: RpcOptions): UnaryCall<BatchDeleteExaminationRelationshipByExaminerAccountIdRequest, BatchDeleteExaminationRelationshipByExaminerAccountIdResponse> {
        const method = this.methods[20], opt = this._transport.mergeOptions(options);
        return stackIntercept<BatchDeleteExaminationRelationshipByExaminerAccountIdRequest, BatchDeleteExaminationRelationshipByExaminerAccountIdResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * 绑定accountId
     *
     * @generated from protobuf rpc: SetAccountIdForExaminee
     */
    setAccountIdForExaminee(input: SetAccountIdForExamineeRequest, options?: RpcOptions): UnaryCall<SetAccountIdForExamineeRequest, SetAccountIdForExamineeResponse> {
        const method = this.methods[21], opt = this._transport.mergeOptions(options);
        return stackIntercept<SetAccountIdForExamineeRequest, SetAccountIdForExamineeResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SetExamineeAccountId
     */
    setExamineeAccountId(input: SetExamineeAccountIdRequest, options?: RpcOptions): UnaryCall<SetExamineeAccountIdRequest, Empty> {
        const method = this.methods[22], opt = this._transport.mergeOptions(options);
        return stackIntercept<SetExamineeAccountIdRequest, Empty>("unary", this._transport, method, opt, input);
    }
    /**
     * 修改检测对象信息
     *
     * @generated from protobuf rpc: UpdateExaminee
     */
    updateExaminee(input: UpdateExamineeRequest, options?: RpcOptions): UnaryCall<UpdateExamineeRequest, UpdateExamineeResponse> {
        const method = this.methods[23], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateExamineeRequest, UpdateExamineeResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * 获取检测对象通过检测对象id
     *
     * @generated from protobuf rpc: GetExamineeById
     */
    getExamineeById(input: GetExamineeByIdRequest, options?: RpcOptions): UnaryCall<GetExamineeByIdRequest, GetExamineeByIdResponse> {
        const method = this.methods[24], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetExamineeByIdRequest, GetExamineeByIdResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * 通过examinee自己的account_id获取检测对象信息，参见：CreateExaminee
     *
     * @generated from protobuf rpc: GetExamineeByAccountId
     */
    getExamineeByAccountId(input: GetExamineeByAccountIdRequest, options?: RpcOptions): UnaryCall<GetExamineeByAccountIdRequest, GetExamineeByAccountIdResponse> {
        const method = this.methods[25], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetExamineeByAccountIdRequest, GetExamineeByAccountIdResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetMyExaminee
     */
    getMyExaminee(input: GetMyExamineeRequest, options?: RpcOptions): UnaryCall<GetMyExamineeRequest, GetMyExamineeResponse> {
        const method = this.methods[26], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetMyExamineeRequest, GetMyExamineeResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * 根据accountId查找检测对象列表
     *
     * @generated from protobuf rpc: GetExamineeListByExaminerAccountId
     */
    getExamineeListByExaminerAccountId(input: GetExamineeListByExaminerAccountIdRequest, options?: RpcOptions): UnaryCall<GetExamineeListByExaminerAccountIdRequest, GetExamineeListByExaminerAccountIdResponse> {
        const method = this.methods[27], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetExamineeListByExaminerAccountIdRequest, GetExamineeListByExaminerAccountIdResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * 获取检验人报告列表
     *
     * @generated from protobuf rpc: GetExamineesExaminationReportList
     */
    getExamineesExaminationReportList(input: GetExamineesExaminationReportListRequest, options?: RpcOptions): UnaryCall<GetExamineesExaminationReportListRequest, GetExamineesExaminationReportListResponse> {
        const method = this.methods[28], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetExamineesExaminationReportListRequest, GetExamineesExaminationReportListResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * 添加查验人
     *
     * @generated from protobuf rpc: CreateExaminer
     */
    createExaminer(input: CreateExaminerRequest, options?: RpcOptions): UnaryCall<CreateExaminerRequest, CreateExaminerResponse> {
        const method = this.methods[29], opt = this._transport.mergeOptions(options);
        return stackIntercept<CreateExaminerRequest, CreateExaminerResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * 添加查验人
     *
     * @generated from protobuf rpc: CreateExaminerByAccountId
     */
    createExaminerByAccountId(input: CreateExaminerByAccountIdRequest, options?: RpcOptions): UnaryCall<CreateExaminerByAccountIdRequest, CreateExaminerByAccountIdResponse> {
        const method = this.methods[30], opt = this._transport.mergeOptions(options);
        return stackIntercept<CreateExaminerByAccountIdRequest, CreateExaminerByAccountIdResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * 根据检测人ID获取检测人信息
     *
     * @generated from protobuf rpc: GetExaminerByAccountId
     */
    getExaminerByAccountId(input: GetExaminerByAccountIdRequest, options?: RpcOptions): UnaryCall<GetExaminerByAccountIdRequest, GetExaminerByAccountIdResponse> {
        const method = this.methods[31], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetExaminerByAccountIdRequest, GetExaminerByAccountIdResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * 获取查验人列表
     *
     * @generated from protobuf rpc: GetMyAllExaminers
     */
    getMyAllExaminers(input: GetMyAllExaminersRequest, options?: RpcOptions): UnaryCall<GetMyAllExaminersRequest, GetMyAllExaminersResponse> {
        const method = this.methods[32], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetMyAllExaminersRequest, GetMyAllExaminersResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * 查看我的检测人关系（还有能否操作）
     *
     * @generated from protobuf rpc: GetExaminationRelationshipByAccessToken
     */
    getExaminationRelationshipByAccessToken(input: GetExaminationRelationshipByAccessTokenRequest, options?: RpcOptions): UnaryCall<GetExaminationRelationshipByAccessTokenRequest, GetExaminationRelationshipByAccessTokenResponse> {
        const method = this.methods[33], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetExaminationRelationshipByAccessTokenRequest, GetExaminationRelationshipByAccessTokenResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ListExaminers
     */
    listExaminers(input: ListExaminersRequest, options?: RpcOptions): UnaryCall<ListExaminersRequest, ListExaminersResponse> {
        const method = this.methods[34], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListExaminersRequest, ListExaminersResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * 修改被检测人关系
     *
     * @generated from protobuf rpc: UpdateExaminationRelationshipById
     */
    updateExaminationRelationshipById(input: UpdateExaminationRelationshipByIdRequest, options?: RpcOptions): UnaryCall<UpdateExaminationRelationshipByIdRequest, UpdateExaminationRelationshipByIdResponse> {
        const method = this.methods[35], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateExaminationRelationshipByIdRequest, UpdateExaminationRelationshipByIdResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * 获取被检测人列表通过被检测人id
     *
     * @generated from protobuf rpc: GetExamineeListByIds
     */
    getExamineeListByIds(input: GetExamineeListByIdsRequest, options?: RpcOptions): UnaryCall<GetExamineeListByIdsRequest, GetExamineeListByIdsResponse> {
        const method = this.methods[36], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetExamineeListByIdsRequest, GetExamineeListByIdsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * 根据examineeAccountId和client获取Examinee列表信息
     *
     * @generated from protobuf rpc: ListExamineeListByExamineeAccountIds
     */
    listExamineeListByExamineeAccountIds(input: ListExamineeListByExamineeAccountIdsRequest, options?: RpcOptions): UnaryCall<ListExamineeListByExamineeAccountIdsRequest, ListExamineeListByExamineeAccountIdsResponse> {
        const method = this.methods[37], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListExamineeListByExamineeAccountIdsRequest, ListExamineeListByExamineeAccountIdsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * 根据被检测人名字查看被检测者信息列表
     *
     * @generated from protobuf rpc: ListExaminee
     */
    listExaminee(input: ListExamineeRequest, options?: RpcOptions): UnaryCall<ListExamineeRequest, ListExamineeResponse> {
        const method = this.methods[38], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListExamineeRequest, ListExamineeResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CountExamineeByExaminers
     */
    countExamineeByExaminers(input: CountExamineeByExaminersRequest, options?: RpcOptions): UnaryCall<CountExamineeByExaminersRequest, CountExamineeByExaminersResponse> {
        const method = this.methods[39], opt = this._transport.mergeOptions(options);
        return stackIntercept<CountExamineeByExaminersRequest, CountExamineeByExaminersResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * 分页查看检测对象列表，根据accountId
     *
     * @generated from protobuf rpc: PageListExaminee
     */
    pageListExaminee(input: PageListExamineeRequest, options?: RpcOptions): UnaryCall<PageListExamineeRequest, PageListExamineeResponse> {
        const method = this.methods[40], opt = this._transport.mergeOptions(options);
        return stackIntercept<PageListExamineeRequest, PageListExamineeResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * 获取症状标签列表
     *
     * @generated from protobuf rpc: ListSymptoms
     */
    listSymptoms(input: ListSymptomsRequest, options?: RpcOptions): UnaryCall<ListSymptomsRequest, ListSymptomsResponse> {
        const method = this.methods[41], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListSymptomsRequest, ListSymptomsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * 获取症状标签列表
     *
     * @generated from protobuf rpc: DeleteSymptoms
     */
    deleteSymptoms(input: DeleteSymptomsRequest, options?: RpcOptions): UnaryCall<DeleteSymptomsRequest, Empty> {
        const method = this.methods[42], opt = this._transport.mergeOptions(options);
        return stackIntercept<DeleteSymptomsRequest, Empty>("unary", this._transport, method, opt, input);
    }
    /**
     * region 检测报告
     * 增加一份报告
     *
     * @generated from protobuf rpc: CreateExaminationReport
     */
    createExaminationReport(input: CreateExaminationReportRequest, options?: RpcOptions): UnaryCall<CreateExaminationReportRequest, CreateExaminationReportResponse> {
        const method = this.methods[43], opt = this._transport.mergeOptions(options);
        return stackIntercept<CreateExaminationReportRequest, CreateExaminationReportResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * 修改报告
     *
     * @generated from protobuf rpc: UpdateExaminationReport
     */
    updateExaminationReport(input: UpdateExaminationReportRequest, options?: RpcOptions): UnaryCall<UpdateExaminationReportRequest, UpdateExaminationReportResponse> {
        const method = this.methods[44], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateExaminationReportRequest, UpdateExaminationReportResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * 获取我的报告列表
     *
     * @generated from protobuf rpc: GetMyExaminationReportList
     */
    getMyExaminationReportList(input: GetMyExaminationReportListRequest, options?: RpcOptions): UnaryCall<GetMyExaminationReportListRequest, GetMyExaminationReportListResponse> {
        const method = this.methods[45], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetMyExaminationReportListRequest, GetMyExaminationReportListResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * 查询一份检测报告记录详情
     *
     * @generated from protobuf rpc: GetExaminationReportById
     */
    getExaminationReportById(input: GetExaminationReportByIdRequest, options?: RpcOptions): UnaryCall<GetExaminationReportByIdRequest, GetExaminationReportByIdResponse> {
        const method = this.methods[46], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetExaminationReportByIdRequest, GetExaminationReportByIdResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * 分享一份报告
     *
     * @generated from protobuf rpc: AddExaminationReport
     */
    addExaminationReport(input: AddExaminationReportRequest, options?: RpcOptions): UnaryCall<AddExaminationReportRequest, AddExaminationReportResponse> {
        const method = this.methods[47], opt = this._transport.mergeOptions(options);
        return stackIntercept<AddExaminationReportRequest, AddExaminationReportResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ShareExaminationReport
     */
    shareExaminationReport(input: ShareExaminationReportRequest, options?: RpcOptions): UnaryCall<ShareExaminationReportRequest, Empty> {
        const method = this.methods[48], opt = this._transport.mergeOptions(options);
        return stackIntercept<ShareExaminationReportRequest, Empty>("unary", this._transport, method, opt, input);
    }
    /**
     * 删除我的一份检测报告记录
     *
     * @generated from protobuf rpc: DeleteExaminationReportRelationship
     */
    deleteExaminationReportRelationship(input: DeleteExaminationReportRelationshipRequest, options?: RpcOptions): UnaryCall<DeleteExaminationReportRelationshipRequest, DeleteExaminationReportRelationshipResponse> {
        const method = this.methods[49], opt = this._transport.mergeOptions(options);
        return stackIntercept<DeleteExaminationReportRelationshipRequest, DeleteExaminationReportRelationshipResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * 删除我作为检测对象下所有的检测报告记录（既删除包括我分享出去或别人为我检测的报告记录）
     *
     * @generated from protobuf rpc: DeleteAllExaminationReportRelationship
     */
    deleteAllExaminationReportRelationship(input: DeleteAllExaminationReportRelationshipRequest, options?: RpcOptions): UnaryCall<DeleteAllExaminationReportRelationshipRequest, DeleteAllExaminationReportRelationshipResponse> {
        const method = this.methods[50], opt = this._transport.mergeOptions(options);
        return stackIntercept<DeleteAllExaminationReportRelationshipRequest, DeleteAllExaminationReportRelationshipResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: DeleteExaminationReportByDetailId
     */
    deleteExaminationReportByDetailId(input: DeleteExaminationReportByDetailIdRequest, options?: RpcOptions): UnaryCall<DeleteExaminationReportByDetailIdRequest, DeleteExaminationReportByDetailIdResponse> {
        const method = this.methods[51], opt = this._transport.mergeOptions(options);
        return stackIntercept<DeleteExaminationReportByDetailIdRequest, DeleteExaminationReportByDetailIdResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * 获取检验人报告列表（根据examineeId和检测类型获取检测者某一类型的报告列表）
     *
     * @generated from protobuf rpc: GetExamineesExaminationReportListByReportType
     */
    getExamineesExaminationReportListByReportType(input: GetExamineesExaminationReportListByReportTypeRequest, options?: RpcOptions): UnaryCall<GetExamineesExaminationReportListByReportTypeRequest, GetExamineesExaminationReportListByReportTypeResponse> {
        const method = this.methods[52], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetExamineesExaminationReportListByReportTypeRequest, GetExamineesExaminationReportListByReportTypeResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * 获取报告列表
     *
     * @generated from protobuf rpc: GetExaminationReportPageByAccountId
     */
    getExaminationReportPageByAccountId(input: GetExaminationReportPageByAccountIdRequest, options?: RpcOptions): UnaryCall<GetExaminationReportPageByAccountIdRequest, GetExaminationReportPageByAccountIdResponse> {
        const method = this.methods[53], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetExaminationReportPageByAccountIdRequest, GetExaminationReportPageByAccountIdResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * 获取报告列表
     *
     * @generated from protobuf rpc: GetExaminationReportPageByAccountIdAndType
     */
    getExaminationReportPageByAccountIdAndType(input: GetExaminationReportPageByAccountIdAndTypeRequest, options?: RpcOptions): UnaryCall<GetExaminationReportPageByAccountIdAndTypeRequest, GetExaminationReportPageByAccountIdAndTypeResponse> {
        const method = this.methods[54], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetExaminationReportPageByAccountIdAndTypeRequest, GetExaminationReportPageByAccountIdAndTypeResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * 获取报告列表
     *
     * @generated from protobuf rpc: GetExaminationReportPageByExamineeId
     */
    getExaminationReportPageByExamineeId(input: GetExaminationReportPageByExamineeIdRequest, options?: RpcOptions): UnaryCall<GetExaminationReportPageByExamineeIdRequest, GetExaminationReportPageByExamineeIdResponse> {
        const method = this.methods[55], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetExaminationReportPageByExamineeIdRequest, GetExaminationReportPageByExamineeIdResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * 获取报告列表
     *
     * @generated from protobuf rpc: GetExaminationReportPageByExamineeIdAndType
     */
    getExaminationReportPageByExamineeIdAndType(input: GetExaminationReportPageByExamineeIdAndTypeRequest, options?: RpcOptions): UnaryCall<GetExaminationReportPageByExamineeIdAndTypeRequest, GetExaminationReportPageByExamineeIdAndTypeResponse> {
        const method = this.methods[56], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetExaminationReportPageByExamineeIdAndTypeRequest, GetExaminationReportPageByExamineeIdAndTypeResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * 根据accessToken获取报告列表
     *
     * @generated from protobuf rpc: GetExaminationReportPageByAccessTokenAndType
     */
    getExaminationReportPageByAccessTokenAndType(input: GetExaminationReportPageByAccessTokenAndTypeRequest, options?: RpcOptions): UnaryCall<GetExaminationReportPageByAccessTokenAndTypeRequest, GetExaminationReportPageByAccessTokenAndTypeResponse> {
        const method = this.methods[57], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetExaminationReportPageByAccessTokenAndTypeRequest, GetExaminationReportPageByAccessTokenAndTypeResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * 修改报告
     *
     * @generated from protobuf rpc: UpdateExaminationReportByExamineeReportDetailId
     */
    updateExaminationReportByExamineeReportDetailId(input: UpdateExaminationReportByExamineeReportDetailIdRequest, options?: RpcOptions): UnaryCall<UpdateExaminationReportByExamineeReportDetailIdRequest, UpdateExaminationReportByExamineeReportDetailIdResponse> {
        const method = this.methods[58], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateExaminationReportByExamineeReportDetailIdRequest, UpdateExaminationReportByExamineeReportDetailIdResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * 查询一份检测报告记录详情
     *
     * @generated from protobuf rpc: GetExaminationReportByExamineeReportDetailId
     */
    getExaminationReportByExamineeReportDetailId(input: GetExaminationReportByExamineeReportDetailIdRequest, options?: RpcOptions): UnaryCall<GetExaminationReportByExamineeReportDetailIdRequest, GetExaminationReportByExamineeReportDetailIdResponse> {
        const method = this.methods[59], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetExaminationReportByExamineeReportDetailIdRequest, GetExaminationReportByExamineeReportDetailIdResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: BatchGetExaminationReportsByDetailId
     */
    batchGetExaminationReportsByDetailId(input: BatchGetExaminationReportsByDetailIdRequest, options?: RpcOptions): UnaryCall<BatchGetExaminationReportsByDetailIdRequest, BatchGetExaminationReportsByDetailIdResponse> {
        const method = this.methods[60], opt = this._transport.mergeOptions(options);
        return stackIntercept<BatchGetExaminationReportsByDetailIdRequest, BatchGetExaminationReportsByDetailIdResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * 根据组织ID和检测类型获取检测列表
     *
     * @generated from protobuf rpc: ListExaminationReportByOrganizationIdAndType
     */
    listExaminationReportByOrganizationIdAndType(input: ListExaminationReportByOrganizationIdAndTypeRequest, options?: RpcOptions): UnaryCall<ListExaminationReportByOrganizationIdAndTypeRequest, ListExaminationReportByOrganizationIdAndTypeResponse> {
        const method = this.methods[61], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListExaminationReportByOrganizationIdAndTypeRequest, ListExaminationReportByOrganizationIdAndTypeResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CountExaminationReportByExaminers
     */
    countExaminationReportByExaminers(input: CountExaminationReportByExaminersRequest, options?: RpcOptions): UnaryCall<CountExaminationReportByExaminersRequest, CountExaminationReportByExaminersResponse> {
        const method = this.methods[62], opt = this._transport.mergeOptions(options);
        return stackIntercept<CountExaminationReportByExaminersRequest, CountExaminationReportByExaminersResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CountExaminationReportByExaminees
     */
    countExaminationReportByExaminees(input: CountExaminationReportByExamineesRequest, options?: RpcOptions): UnaryCall<CountExaminationReportByExamineesRequest, CountExaminationReportByExamineesResponse> {
        const method = this.methods[63], opt = this._transport.mergeOptions(options);
        return stackIntercept<CountExaminationReportByExamineesRequest, CountExaminationReportByExamineesResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ListExaminationReports
     */
    listExaminationReports(input: ListExaminationReportsRequest, options?: RpcOptions): UnaryCall<ListExaminationReportsRequest, ListExaminationReportsResponse> {
        const method = this.methods[64], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListExaminationReportsRequest, ListExaminationReportsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ListExaminationReportHeaders
     */
    listExaminationReportHeaders(input: ListExaminationReportHeadersRequest, options?: RpcOptions): UnaryCall<ListExaminationReportHeadersRequest, ListExaminationReportHeadersResponse> {
        const method = this.methods[65], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListExaminationReportHeadersRequest, ListExaminationReportHeadersResponse>("unary", this._transport, method, opt, input);
    }
}
